import { CssBaseline } from "@mui/material"

import GlobalStyles from "../globalStyles"
import ThemeColorPresets from "./ThemeColorPresets"
import ThemeContrast from "./ThemeContrast"

export default function ThemeSettings({
  children,
  applyGlobalStyle = false,
  disableMode = false,
}: {
  children: React.ReactNode
  applyGlobalStyle: boolean
  disableMode?: boolean
}) {
  return (
    <ThemeColorPresets>
      <ThemeContrast disableMode={disableMode}>
        {applyGlobalStyle && (
          <>
            <GlobalStyles />
            <CssBaseline />
          </>
        )}
        {children}
      </ThemeContrast>
    </ThemeColorPresets>
  )
}
